import { render, staticRenderFns } from "./panelLinePriority.vue?vue&type=template&id=67c88f86&lang=pug"
import script from "./panelLinePriority.vue?vue&type=script&lang=js"
export * from "./panelLinePriority.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports